import { FC } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Menu, Label, MenuItemProps, Container, Popup, Icon, CommentText } from 'semantic-ui-react';
import { lowerFirst, upperFirst, getEnvName, envColor } from '../common';
import { TextCell } from './Table';


export interface MenuItem {
    path: string;
    disabled: boolean;
}

interface MenuProps {
    items: MenuItem[];
}


const MenuImpl: FC<MenuProps> = ({ items }) => {
    const history = useHistory();
    const envName = getEnvName().toUpperCase();
    const { REACT_APP_CURRENT_VERSION: currentVersion } = process.env;
    const { REACT_APP_CURRENT_CHANGE: currentChange } = process.env;

    let activeItem = useLocation().pathname;
    if (activeItem === '/') {
        activeItem = items[0].path;
    }

    const switchMenu = (e: any, { name, path }: MenuItemProps) => {
        if (name === undefined) return;
        history.push('/' + lowerFirst(name));
    };

    const menuItems = items.map((item, i)=> {
        return (
            <Menu.Item
                key={i}
                name={upperFirst(item.path.replace('/', ''))}
                path={item}
                active={item.path === activeItem}
                onClick={switchMenu}
                color={envColor}
                disabled={item.disabled}
            />
        )
    });

    return (
        <Container>
            <Menu pointing secondary defaultActiveIndex={'events'}>
                {menuItems}
            <Menu.Menu position='right'>
            <Popup
            hoverable
            content={
            <div>
            <p>Version: {currentVersion}</p>
            <p>Last commit: {currentChange}</p>
            </div>

            }
            trigger={
                <Menu.Item
                style={{ marginRight: '-30px' }} // Adjust margin to bring them closer

                name='gitlab'
                active={activeItem === 'gitlab'}
                >
                <Icon name='info circle' />
                </Menu.Item>
        }/>
            <Popup
            hoverable
            content={
            <div>
            <p>Powered by: Titan squad</p>
            <p style={{fontSize: '10px'}} >Contact Us: COLL-GLOBAL-TECH-SQUAD-TITAN@lseg.com</p>
            </div>

            }
            trigger={
                <Menu.Item
                style={{ marginRight: '-40px' }} // Adjust margin to bring them closer

                name='help'
                active={activeItem === 'help'}
                >
                <Icon name='bell' />
                </Menu.Item>
            }/>

            <Menu.Item
                name='envName'
            >
                <Label color={envColor}>{envName}</Label>
            </Menu.Item>

            </Menu.Menu>

            </Menu>

        </Container>
    );
};


export default MenuImpl;
